function validate_empty_form(input) {
  return !input || input === ""
}

export default validate_empty_form
